"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var jdStoreRouter = {
  path: '/jdStore',
  component: _layout.default,
  redirect: '/jdStore/jdSkuList',
  name: 'JdStore',
  meta: {
    title: '京东管理',
    icon: 'shopping'
  },
  children: [{
    path: 'jdSkuList',
    name: 'JdSkuList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jdStore/jdSkuList/index.vue'));
      });
    },
    meta: {
      title: '京东SKU列表',
      icon: ''
    }
  }, {
    path: 'jdSrot',
    name: 'JdSrot',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jdStore/jdSrot/index.vue'));
      });
    },
    meta: {
      title: '京东分类',
      icon: ''
    }
  }]
};
var _default = exports.default = jdStoreRouter;